const training_student_routes = {
      path: "/student",
      name: "Student",
      component: () => import("@/components/LayOut/Main"),
      meta: {requiresAuth: true},
      children: [
        {
          path: "student_index",
          component: () => import("@/views/training_student/studentIndex"),
          meta: {requiresAuth: true},
        },
        {
          path: "class_detail",
          component: () => import('@/views/training_student/class-detail'),
          meta: {requiresAuth: true},
        },
        {
          path: "tutorial_res",
          component: () => import('@/views/training_student/tutorial-official'),
          meta: {requiresAuth: true},
        },
        {
          path: "tutorial_other",
          component: () => import('@/views/training_student/tutorial-person'),
          meta: {requiresAuth: true},
        },
        {
          path: "tutorial_detail",
          component: () => import('@/components/Tutorial/tutorial-detail'),
          meta: {requiresAuth: true},
        },
        {
          path: "edit_tutorial",
          component: () => import('@/views/training_student/edit-tutorial'),
          meta: {requiresAuth: true},
        },
        {
          path: "create_tutorial",
          component: () => import('@/views/training_student/create-tutorial'),
          meta: {requiresAuth: true},
        },
        {
          path: "won",
          component: () => import('@/views/training_student/Wonderful'),
          meta: {requiresAuth: true},
        },
        // 测评
        {
          path: 'create_evaluation',
          name: 'StuCreateEvaluation',
          component: () => import('@/views/training_student/CreateEvaluation'),
          props: true,
          meta: {requiresAuth: true},
        },
        // 报名表 basicSetting
        {
          path: "vita",
          component: () => import('@/views/training_student/vita/vita'),
          meta: {requiresAuth: true},
        },
        {
          path: "basicSetting",
          component: () => import('@/views/training_expire_student/basicSetting'),
          meta: {requiresAuth: true},
        },
        {
          path:'qualificationSetting',
          component: () => import('@/views/training_expire_student/qualificationSetting'),
          meta: {requiresAuth: true},
        },
        {
          path: "tran_his",
          name: 'stuTrainingHis',
          component: () => import('@/views/TraingingManager/TrainingHis/TrainingHis'),
          meta: {requiresAuth: true},
        },
        {
          path: "tea_sd",
          component: () => import('@/views/training_teacher/stu-detail'),
          meta: {requiresAuth: true},
        },
        {
          path: "stu_tutorial",
          component: () => import('@/views/training_teacher/student-tutorial'),
          meta: {requiresAuth: true},
        },
        {
          path: "getLicenseList",
          component: () => import('@/views/training_expire_student/licenseList'),
          meta: {requiresAuth: true},
        },
        /* 学习资料列表 */
        {
          path:'materials',
          component: () => import('@/views/Materials/Documents'),
          meta: {requiresAuth: true}
        },
        /* 继续教育创建教案页面 */
        {
          path: "tutorial_other_education",
          component: () => import('@/views/training_student/tutorial-person-education'),
          meta: {requiresAuth: true},
        },
        {
          path:"registrationList",
          component: () => import("@/views/Registration/registration-list"),
          meta:{requiresAuth:true}
        },
        {
          path:"continueList",
          component: () => import("@/views/Registration/continue-list"),
          meta:{requiresAuth:true}
        },
        {
          path:"registrationList",
          component: () => import("@/views/Registration/registration-list"),
          meta:{requiresAuth:true}
        },
        {
          path: "register_vita",
          component: () => import('@/views/Registration/vita/vita'),
          meta: {requiresAuth: true},
        },
        // 报名详情
        {
          path: "register_info",
          component: () => import('@/components/Registration/RegistrationInfo'),
          meta: {requiresAuth: true},
        },
        // 上传附件
        {
          path: "register_file",
          component: () => import('@/views/Registration/vita/vitaFile'),
          meta: {requiresAuth: true},
        },
        /* 继续教育列表 */
        {
          path:'education_list',
          component: () => import('@/views/Education/educationList'),
          meta: {requiresAuth: true}
        },
        /* 进入继续教育详情 */
        {
          path:'education_info_to_stu',
          component: () => import('@/views/Education/educationDetailToStu'),
          meta: {requiresAuth: true}
        },
        /* 继续教育学习页面 */
        {
          path:'education_learn_to_stu',
          component: () => import('@/views/Education/educationLearn'),
          meta: {requiresAuth: true}
        },
        {
          path:"classComplaintAdd",
          name:'ClassComplaintAdd',
          component:()=> import("@/components/ClassComplaint/ClassComplaintAdd"),
          meta: {requiresAuth: true}
        },
        // 确认预录取
        {
          path: 'confirmPreAdmission',
          name: 'ConfirmPreAdmission',
          component: () => import('@/views/training_expire_student/confirmPreAdmission'),
          props: true,
          meta: {requiresAuth: true},
        },
        /* 投诉详情 */
        {
          path:'feedbackInfo',
          name: 'FeedbackInfo',
          component: () => import('@/views/system_manager/feedback/components/feedbackInfo'),
          meta: {requiresAuth: true}
        },
        // 上传附件
        {
          path: "enroll_choose_again",
          component: () => import('@/views/Registration/vita/enroll_choose_again'),
          meta: {requiresAuth: true},
        },
        /* 课堂笔记列表 */
        {
          path:'classNotes',
          component: () => import('@/views/ClassNotes/Documents'),
          meta: {requiresAuth: true}
        },
      ]
    }

export default training_student_routes
